import Ingestion from "./ingestion";
import Create from "./create";

export default {
  Ingestion,
  Create
};
